import type {
    BulkOnboardingLocationPagePropertyOnboardingContextFieldsV1,
    BulkOnboardingLocationPagePropertyOnboardingContextIdsV1,
} from "@agoda/analytics-messages-definition-property-onboarding/contexts.split";
import {
    BulkOnboardingLocationPagePropertyOnboardingContextManifestV1,
    WebBulkOnboardingLocationPageVisitEventPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/bulk-onboarding-location-page";
import {
    AddLocationElementPropertyOnboardingManifestV1,
    BuildingElementPropertyOnboardingManifestV1,
    BulkOnboardingBackElementPropertyOnboardingManifestV1,
    BulkOnboardingNextElementPropertyOnboardingManifestV1,
    BulkOnboardingSaveAndExitElementPropertyOnboardingManifestV1,
    CancelLocationElementPropertyOnboardingManifestV1,
    CancelRemoveListingElementPropertyOnboardingManifestV1,
    CityElementPropertyOnboardingManifestV1,
    CloseLocationModalElementPropertyOnboardingManifestV1,
    ConfirmLocationElementPropertyOnboardingManifestV1,
    ConfirmRemoveListingElementPropertyOnboardingManifestV1,
    CountryRegionElementPropertyOnboardingManifestV1,
    EditLocationElementPropertyOnboardingManifestV1,
    LocationEnterManuallyElementPropertyOnboardingManifestV1,
    LocationGoogleMapElementPropertyOnboardingManifestV1,
    LocationModalElementPropertyOnboardingManifestV1,
    LocationSearchFieldElementPropertyOnboardingManifestV1,
    MoreActionsElementPropertyOnboardingManifestV1,
    PleaseAddLocationElementPropertyOnboardingManifestV1,
    RemoveListingElementPropertyOnboardingManifestV1,
    StateProvinceElementPropertyOnboardingManifestV1,
    StreetAddressElementPropertyOnboardingManifestV1,
    ZipPostalCodeElementPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/elements";
import { BaseContextFieldsMapping, GetAttributeSafe } from "libs/analytics/functions/appContext";
import { defineBinder } from "libs/analytics/functions/defineBinder";

export const batchLocationBinder = defineBinder(({ webAnalytics, action: { click, reveal } }) => {
    webAnalytics.pageContext<
        BulkOnboardingLocationPagePropertyOnboardingContextIdsV1,
        BulkOnboardingLocationPagePropertyOnboardingContextFieldsV1
    >(BulkOnboardingLocationPagePropertyOnboardingContextManifestV1.ids, {
        auth_user_id: BaseContextFieldsMapping.auth_user_id,
        member_id: BaseContextFieldsMapping.member_id,
        is_internal_user: BaseContextFieldsMapping.is_internal_user,
    });

    webAnalytics.observe(WebBulkOnboardingLocationPageVisitEventPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], BulkOnboardingSaveAndExitElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], BulkOnboardingBackElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], BulkOnboardingNextElementPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], AddLocationElementPropertyOnboardingManifestV1.ids, {
        property_id: (element: HTMLElement) => GetAttributeSafe(element, "data-property-id"),
        onboarding_id: (element: HTMLElement) => GetAttributeSafe(element, "data-onboarding-id"),
    });
    webAnalytics.observeElement([click], EditLocationElementPropertyOnboardingManifestV1.ids, {
        property_id: (element: HTMLElement) => GetAttributeSafe(element, "data-property-id"),
        onboarding_id: (element: HTMLElement) => GetAttributeSafe(element, "data-onboarding-id"),
    });
    webAnalytics.observeElement([click], MoreActionsElementPropertyOnboardingManifestV1.ids, {
        property_id: (element: HTMLElement) => GetAttributeSafe(element, "data-property-id"),
        onboarding_id: (element: HTMLElement) => GetAttributeSafe(element, "data-onboarding-id"),
    });

    webAnalytics.observeElement([click], RemoveListingElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ConfirmRemoveListingElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], CancelRemoveListingElementPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([reveal], PleaseAddLocationElementPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([reveal], LocationModalElementPropertyOnboardingManifestV1.ids, {
        property_id: (element: HTMLElement) => GetAttributeSafe(element, "data-property-id"),
        onboarding_id: (element: HTMLElement) => GetAttributeSafe(element, "data-onboarding-id"),
    });
    webAnalytics.observeElement([click], CloseLocationModalElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ConfirmLocationElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], CancelLocationElementPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], LocationSearchFieldElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], LocationEnterManuallyElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], LocationGoogleMapElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], CountryRegionElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], StateProvinceElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], CityElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], StreetAddressElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], BuildingElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ZipPostalCodeElementPropertyOnboardingManifestV1.ids, {});
});
